import { stdObject } from "../../../../data/types/stdObject";

export const initSearchValue = (code: string, params: stdObject) => {
  switch (code) {
    case "PERICO":
      const { user, userAccess } = params;
      return userAccess.D.D2 === 2 ? user.CODUSU : "";
    default:
      return "";
  }
};
